import React from 'react'

const Exchanges = () => {
  return (
    <div>Exchanges Not Available</div>

  )};

export default Exchanges